import React from "react";

const Guideline = () => {
  return (
    <>
      <div className="common-banner">
        <div className="container">
          <div className="common-head">
            <h1>Community Guideline</h1>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="group-guideline-desc">
          <div className="desc-space-guide">
            <h5 className="sub-heading mb-4">INTransit community guidelines</h5>
            <p>
              InTransit Inc. (“InTransit”) actively encourages its clients and
              members of the public (“Community Members”) to engage and debate
              on important issues of the day though its online forum. These
              guidelines are meant to govern these discussions and to facilitate
              a safe, productive, and enlightening experience for all
              participants. By accessing InTransit’s online community and
              submitting content, Community Members consent to the following
              terms of use and agree to abide by these guidelines:
            </p>

            <p>You agree not to submit inappropriate content.</p>
            <h6 style={{ textTransform: "uppercase", marginBottom: "20px" }}>
              Inappropriate content includes any content that:
            </h6>
            <p>
              infringes upon or violates the copyrights, trademarks or other
              intellectual property rights of any person
            </p>
            <p>is libelous or defamatory</p>
            <p>is obscene, pornographic, sexually explicit, or vulgar</p>
            <p>violates a person’s right to privacy</p>
            <p>violates any local, state, national, or international law</p>
            <p>contains or advocates illegal or violent acts</p>
            <p>
              degrades others on the basis of gender, race, class, ethnicity,
              national origin, religion, sexual orientation, disability, or
              other classification
            </p>
            <p>
              is predatory, hateful, or intended to intimidate or harass, or
              contains derogatory name-calling
            </p>
            <p>
              is a duplicate or repost of something you’ve already posted on the
              site
            </p>
            <p>contains advertising</p>
            <p>contains a solicitation of any kind</p>
            <p>misrepresents your identity or affiliation</p>
            <p>impersonates others</p>
            <p>is in poor taste or is otherwise objectionable</p>
            <p>
              You agree that you are fully responsible for the content that you
              submit.
            </p>
            <p>
              By posting content, you represent and warrant that the content
              abides by the Community Guidelines and agreed that you will remove
              any content that violates these Guidelines. You further agree that
              you will indemnify InTransit and its affiliates and their
              subsidiaries, and its and their directors, officers, managers,
              employees, shareholders, agents, and licensors, from and against
              losses, expenses, damages, and costs, including reasonable
              attorneys’ fees, resulting from any claim brought by any third
              party relating to content you have posted.
            </p>
            <p>
              You understand and agree that InTransit is not responsible for any
              user-submitted content.
            </p>
            <p>
              You acknowledge that InTransit has the right, but not the
              obligation, to monitor submissions and remove content that it
              determines violates these Guidelines. Accordingly, InTransit acts
              as an intermediary through which Community Members can engage and
              share information, and you agree that InTransit is an interactive
              computer service under Section 230 of the Communications Decency
              Act (47 U.S.C. § 230). InTransit further reserves the right to
              reject or remove any content at any time without providing notice
              to you.
            </p>
            <p>
              You certify that you are authorized to share the information or
              content you post.
            </p>
            <p>
              You represent and warrant that content you post is not
              confidential, privileged, contains trade secrets, or otherwise
              violates any person’s intellectual property rights.
            </p>
            <p>
              You acknowledge and agree any use and/or reliance on any
              information obtained through InTransit’s online community.
            </p>
            <p>
              InTransit does not endorse in any manner the content posted by any
              Community Member and likewise does not verify that any of the
              information is accurate or reliable. You should not rely on any
              content or information posted to the online community. If you
              choose to rely on such content or information, you do so at your
              own risk.
            </p>
            <p>
              For any content that you submit, you give InTransit permission to
              use such content.
            </p>
            <p>
              Except as otherwise provided herein, you hereby grant to InTransit
              a royalty-free, irrevocable, perpetual, worldwide, exclusive, and
              fully sublicensable license to use, reproduce, modify, adapt,
              publish, translate, create derivative works from, incorporate into
              other works, distribute, perform, display, and otherwise exploit
              such content, in whole or in part in any form, media or technology
              now known or later developed.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Guideline;
